import classList from 'flarum/common/utils/classList';
/**
 * The theme's page hero (hero.less): a big left-aligned title and a subtitle
 * on the soft glow, over the icon strip. Every page hero has a subtitle, so
 * moving between pages doesn't change the hero's height.
 */
export default function pageHero(title, subtitle, className) {
  return m("header", {
    className: classList('Hero BdPageHero', className)
  }, m("div", {
    className: "container"
  }, m("div", {
    className: "containerNarrow"
  }, m("h1", {
    className: "Hero-title"
  }, title), m("div", {
    className: "Hero-subtitle"
  }, subtitle))));
}